import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../api";
import { NotificationManager } from "react-notifications";
import { POST2 } from "../api/index2";
const userSlice = createSlice({
  name: "user",
  initialState: { status: "idle", data: [], data2: [], imageToFileFeed: [], productName: [], lowes: [], amazon: [], product: [], data3: [], isLogin: false, rule: null, user: {}, isLoading: false, tiktok: [], dataVariable: [], aliexpress: [], dickssportinggoods: [], walmart: [], macys: [], petco: [], homedepot: [], checkproxy: [], uploadMoreImagesResults: [] },
  reducers: {
    // IMMER
    addTodo: (state, action) => {
      state.push(action.payload);
    }, // action creators
    toggleTodoStatus: (state, action) => {
      const currentTodo = state.find((todo) => todo.id === action.payload);
      if (currentTodo) {
        currentTodo.completed = !currentTodo.completed;
      }
    }, setLoading: (state, action) => {
      // state.isLoading = action.payload;
    }, stopLoading: (state) => {
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder

      //product

      .addCase(getAllNameProduct.fulfilled, (state, action) => {
        const res = action.payload;
        state.productName = res.data;
      })
      .addCase(getOnlyProduct.fulfilled, (state, action) => {
        const res = action.payload;
        state.product = res.data;
      })
      .addCase(editProduct.fulfilled, (state, action) => {
      })



      .addCase(getData.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.data = res;
        state.isLoading = false;
      })
      .addCase(getData.pending, (state, action) => {
        NotificationManager.success("Đang gửi request !", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(getData.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(getData2.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.data2 = res;
        state.isLoading = false;
      })
      .addCase(getData2.pending, (state, action) => {
        NotificationManager.success("Đang gửi request !", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(getData2.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })


      .addCase(imageToFileFeed.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.imageToFileFeed = res;
        state.isLoading = false;
      })
      .addCase(imageToFileFeed.pending, (state, action) => {
        NotificationManager.success("Đang gửi request !", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(imageToFileFeed.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })


      .addCase(getData3.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.data3 = res;
        state.isLoading = false;
      })
      .addCase(getData3.pending, (state, action) => {
        NotificationManager.success("Đang gửi request !", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(getData3.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(getData4.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.data3 = res;
        state.isLoading = false;
      })
      .addCase(getData4.pending, (state, action) => {
        NotificationManager.success("Đang gửi request !", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(getData4.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })


      .addCase(getVa.fulfilled, (state, action) => {
        const res = action.payload;
        state.dataVariable = res.data;
        state.isLoading = false;
      })
      .addCase(getVa.rejected, (state, action) => {
        NotificationManager.error("Không thể lấy biến thể!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(delVa.fulfilled, (state, action) => {
        const res = action.payload;
        res.status == "success" ? NotificationManager.success(res.message, "Alert", 2000) : NotificationManager.error(res.message, "Alert", 2000)
        state.isLoading = false;
      })
      .addCase(delVa.pending, (state, action) => {
        NotificationManager.success("Đang gửi request!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(delVa.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(addVa.fulfilled, (state, action) => {
        const res = action.payload;
        res.status == "success" ? NotificationManager.success(res.message, "Alert", 2000) : NotificationManager.error(res.message, "Alert", 2000)
        state.isLoading = false;
      })
      .addCase(addVa.pending, (state, action) => {
        NotificationManager.success("Đang gửi request!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(addVa.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
      .addCase(aliexpress.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.aliexpress = res;
        state.isLoading = false;
      })
      .addCase(aliexpress.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(aliexpress.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
      .addCase(dickssportinggoods.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.dickssportinggoods = res;
        state.isLoading = false;
      })
      .addCase(dickssportinggoods.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(dickssportinggoods.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
      .addCase(walmart.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.walmart = res;
        state.isLoading = false;
      })
      .addCase(walmart.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(walmart.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
      .addCase(macys.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.macys = res;
        state.isLoading = false;
      })
      .addCase(macys.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(macys.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(amazon.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.amazon = res;
        state.isLoading = false;
      })
      .addCase(amazon.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(amazon.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(petco.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.petco = res;
        state.isLoading = false;
      })
      .addCase(petco.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(petco.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(homedepot.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.homedepot = res;
        state.isLoading = false;
      })
      .addCase(homedepot.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(homedepot.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(lowes.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.lowes = res;
        state.isLoading = false;
      })
      .addCase(lowes.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(lowes.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })

      .addCase(checkproxy.fulfilled, (state, action) => {
        const res = action.payload;
        NotificationManager.success("Thành công!", "Alert", 2000);
        state.checkproxy = res;
        state.isLoading = false;
      })
      .addCase(checkproxy.pending, (state, action) => {
        NotificationManager.success("Đang crawler!", "Alert", 2000);
        state.isLoading = true;
      })
      .addCase(checkproxy.rejected, (state, action) => {
        NotificationManager.error("Thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
      .addCase(uploadMoreImages.fulfilled, (state, action) => {
        const res = action.payload;
        state.uploadMoreImagesResults = [...(state.uploadMoreImagesResults || []), res];
        state.isLoading = false;
      })
      .addCase(uploadMoreImages.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(uploadMoreImages.rejected, (state, action) => {
        NotificationManager.error("Upload thất bại!", "Alert", 2000);
        state.isLoading = false;
      })
  },
});

export const getAllNameProduct = createAsyncThunk("user/getAllNameProduct", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await GET("/getallproductfile", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});
export const getOnlyProduct = createAsyncThunk("user/getOnlyProduct", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/getonlyproductfile", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});
export const editProduct = createAsyncThunk("user/editProduct", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/updateproductfile", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const addProduct = createAsyncThunk("user/editProduct", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/updateproductfile", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});


export const getData = createAsyncThunk("user/convert", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/convert", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const getData2 = createAsyncThunk("user/convert2", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/convert2", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const imageToFileFeed = createAsyncThunk("user/imagetofilefeed", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/imagetofilefeed", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const getData3 = createAsyncThunk("user/sheetimgconvert", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/sheetimgconvert", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const getData4 = createAsyncThunk("user/sheetimgconvert2", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/sheetimgconvert2", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});


export const addVa = createAsyncThunk("user/addVa", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/addvariable", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});
export const delVa = createAsyncThunk("user/delVa", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST("/delvariable", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});
export const getVa = createAsyncThunk("user/getVa", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await GET("/getvariable", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});


export const aliexpress = createAsyncThunk("user/aliexpress", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/aliexpress", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const dickssportinggoods = createAsyncThunk("user/dickssportinggoods", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/dickssportinggoods", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const walmart = createAsyncThunk("user/walmart", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/walmart", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const petco = createAsyncThunk("user/petco", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/petco", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const macys = createAsyncThunk("user/macys", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/macys", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const homedepot = createAsyncThunk("user/homedepot", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/homedepot", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const lowes = createAsyncThunk("user/lowes", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/lowes", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const amazon = createAsyncThunk("user/amazon", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await POST2("/amazon", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export const checkproxy = createAsyncThunk("user/checkproxy", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));
    const res = await GET("/proxyscore", newTodo);
    dispatch(userSlice.actions.setLoading(false));
    return res.data;
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

// Helper function để gọi Digital Ocean Function với mảng ảnh
const callDigitalOceanFunction = async (functionUrl, payload) => {
  try {
    const response = await fetch(functionUrl, {
      method: 'POST',
      mode: 'cors', // Explicitly set CORS mode
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();

    // Xử lý format response: có thể là {statusCode, body} hoặc mảng trực tiếp
    if (result.statusCode === 200 && result.body) {
      // Format: {statusCode: 200, body: {results: [...], success: true}}
      if (result.body.results && Array.isArray(result.body.results)) {
        return result.body.results;
      }
      // Format: {statusCode: 200, body: [...]} - mảng trực tiếp trong body
      if (Array.isArray(result.body)) {
        return result.body;
      }
    }

    // Nếu response là mảng trực tiếp
    if (Array.isArray(result)) {
      return result;
    }

    throw new Error(result.body?.error || 'Upload failed - invalid response format');
  } catch (error) {
    console.error('Digital Ocean Function error:', error);
    // Provide more detailed error message
    if (error.message && (error.message.includes('Failed to fetch') || error.message.includes('CORS'))) {
      throw new Error(`CORS Error: Server không cho phép request từ origin này. Vui lòng kiểm tra CORS settings trên server hoặc URL: ${functionUrl}`);
    }
    if (error.message && error.message.includes('504')) {
      throw new Error(`Gateway Timeout: Server không phản hồi kịp thời. Vui lòng thử lại sau hoặc kiểm tra server: ${functionUrl}`);
    }
    throw error;
  }
};

// Danh sách các Digital Ocean Function URLs (mảng các server) - Set cứng trong code
const getFunctionUrls = (customUrls) => {
  // Nếu có custom URLs được truyền vào, sử dụng chúng
  if (customUrls && Array.isArray(customUrls) && customUrls.length > 0) {
    return customUrls.filter(url => url && url.trim());
  }

  // Set cứng URLs trong code (tạm thời 3 URLs)
  const defaultUrls = [
    'https://faas-sgp1-18bc02ac.doserverless.co/api/v1/web/fn-df56745b-e606-4bd3-9f93-dc7a07a0746b/default/upload-image',
    'https://faas-sgp1-18bc02ac.doserverless.co/api/v1/web/fn-df56745b-e606-4bd3-9f93-dc7a07a0746b/default/upload-image',
    'https://faas-sgp1-18bc02ac.doserverless.co/api/v1/web/fn-df56745b-e606-4bd3-9f93-dc7a07a0746b/default/upload-image'
  ];

  // Cấu hình qua environment variables (nếu có)
  let functionUrls = [];

  // Ưu tiên: REACT_APP_DO_FUNCTION_URLS (JSON array)
  if (process.env.REACT_APP_DO_FUNCTION_URLS) {
    try {
      functionUrls = JSON.parse(process.env.REACT_APP_DO_FUNCTION_URLS);
      if (Array.isArray(functionUrls) && functionUrls.length > 0) {
        return functionUrls.filter(url => url && url.trim());
      }
    } catch (e) {
      console.error('Error parsing REACT_APP_DO_FUNCTION_URLS:', e);
    }
  }

  // Fallback: Các URL riêng lẻ từ env
  const url1 = process.env.REACT_APP_DO_FUNCTION_URL_1;
  const url2 = process.env.REACT_APP_DO_FUNCTION_URL_2;
  const url3 = process.env.REACT_APP_DO_FUNCTION_URL_3;

  if (url1 || url2 || url3) {
    functionUrls = [url1, url2, url3].filter(url => url && url.trim());
    if (functionUrls.length > 0) {
      return functionUrls;
    }
  }

  // Trả về URLs mặc định (set cứng)
  return defaultUrls;
};

// Lấy URL cho một server index cụ thể
const getFunctionUrl = (serverIndex, customUrls) => {
  const urls = getFunctionUrls(customUrls);
  return urls[serverIndex % urls.length];
};

export const uploadMoreImages = createAsyncThunk("user/uploadMoreImages", async (newTodo, { dispatch }) => {
  try {
    dispatch(userSlice.actions.setLoading(true));

    // Mặc định sử dụng Digital Ocean Function, có thể tắt bằng environment variable
    const useDigitalOceanFunction = process.env.REACT_APP_USE_DO_FUNCTION !== 'false';

    if (useDigitalOceanFunction && newTodo.images && Array.isArray(newTodo.images)) {
      // Lấy mảng URLs của các server (ưu tiên custom URLs nếu có)
      const functionUrls = getFunctionUrls(newTodo.serverUrls);

      // Kiểm tra nếu không có URLs
      if (!functionUrls || functionUrls.length === 0) {
        throw new Error('Không có server URLs được cấu hình. Vui lòng nhập server URLs trong UI hoặc cấu hình qua environment variables.');
      }

      // Chọn server dựa trên serverIndex (round-robin)
      const serverIndex = newTodo.serverIndex !== undefined ? newTodo.serverIndex : 0;
      const functionUrl = functionUrls[serverIndex % functionUrls.length];

      // Gửi mảng ảnh trong 1 API call đến server được chọn
      const results = await callDigitalOceanFunction(functionUrl, {
        images: newTodo.images // Mảng chứa {base64, index, fileName, type}
      });

      dispatch(userSlice.actions.setLoading(false));

      // Xử lý kết quả từ API - format: [{index, fileName, url, success}, ...]
      return results.map((result, idx) => {
        // Nếu result đã có đầy đủ thông tin từ API
        if (result.index !== undefined && result.url !== undefined) {
          return {
            index: result.index,
            url: result.success ? result.url : '',
            fileName: result.fileName || newTodo.images[idx]?.fileName || '',
            status: result.success ? 'success' : 'error',
            error: result.success ? null : (result.error || 'Upload failed')
          };
        }

        // Fallback: nếu format khác
        return {
          index: result.index !== undefined ? result.index : (newTodo.images[idx]?.index || idx),
          url: result.url || '',
          fileName: result.fileName || newTodo.images[idx]?.fileName || '',
          status: result.status || (result.url ? 'success' : 'error'),
          error: result.error || null
        };
      });
    } else {
      // Fallback: Sử dụng endpoint convert2 (single image - backward compatibility)
      const images = newTodo.images || [{
        base64: newTodo.base64,
        index: newTodo.index,
        fileName: newTodo.fileName,
        type: newTodo.type || ""
      }];

      const res = await POST("/convert2", {
        urls: images.map(img => img.base64),
        type: images[0]?.type || "",
      });

      dispatch(userSlice.actions.setLoading(false));

      // Trả về mảng kết quả
      const urls = Array.isArray(res.data) ? res.data : [res.data];
      return urls.map((url, idx) => ({
        url: url,
        index: images[idx]?.index || idx,
        fileName: images[idx]?.fileName || '',
        status: 'success'
      }));
    }
  } catch (error) {
    dispatch(userSlice.actions.setLoading(false));
    throw error;
  }
});

export default userSlice;
